import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { Navbar } from "../../../Components/Navbar/Navbar";
import { Footer } from "../../../Components/Footer/footer";
import "./style.css";

interface Leader {
  name: string;
  role: string;
}

interface Organization {
  id: string;
  name: string;
  sector: string;
  is_sanitas: boolean;
  has_ccm: boolean;
  contact: {
    leaders: Leader[];
    phone: string;
    email: string;
    address: string;
  };
}

export function OrganizatiePage() {
  const { id } = useParams<{ id: string }>();
  const [organization, setOrganization] = useState<Organization | null>(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    topic: "Sesizare cu privire la CCM",
  });

  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "site_content", "member_organizations");
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        const rawOrgs = data.organizations || [];
        const match = (rawOrgs as any[])
          .map(o => ({
            ...o,
            contact: {
              leaders: o.contact?.leaders?.length
                ? o.contact.leaders
                : o.contact?.leader_name
                ? [{ name: o.contact.leader_name, role: "" }]
                : [],
              phone: o.contact?.phone || "",
              email: o.contact?.email || "",
              address: o.contact?.address || "",
            },
          }))
          .find((org: Organization) => org.id === id);
        setOrganization(match || null);
      }
    };
    fetchData();
  }, [id]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: conectare Firebase Function pentru trimitere email
    alert("Mesaj trimis (simulat)");
    setFormData({
      name: "",
      email: "",
      phone: "",
      message: "",
      topic: "Sesizare cu privire la CCM",
    });
  };

  if (!organization) return <div>Se încarcă...</div>;

  return (
    <div className="page-container">
      <Navbar />
      <div className="page-content">
        <h1>{organization.name} – Sector {organization.sector}</h1>

        <div className="org-info-grid">
          <div className="org-box">
            <h3>Contact</h3>
            <ul>
              {organization.contact.leaders.length > 0 ? (
                organization.contact.leaders.map((ldr, i) => (
                  <li key={i}>
                    <strong>{ldr.name}</strong>
                    {ldr.role && <span>: {ldr.role}</span>}
                  </li>
                ))
              ) : (
                <li>Niciun lider specificat</li>
              )}
              <li><strong>Email:</strong> {organization.contact.email}</li>
              <li><strong>Telefon:</strong> {organization.contact.phone}</li>
              <li><strong>Adresă:</strong> {organization.contact.address}</li>
            </ul>
          </div>

          <div className="org-box">
            <h3>CCM la nivel de unitate</h3>
            <ul>
              <li><strong>Organizație Sanitas:</strong> {organization.is_sanitas ? "DA" : "NU"}</li>
              <li><strong>Contract CCM:</strong> {organization.has_ccm ? "DA" : "NU"}</li>
            </ul>
          </div>
        </div>

        <hr />

        <h2>Trimite un mesaj</h2>
        <form onSubmit={handleSubmit} className="org-contact-form">
          <input
            type="text"
            name="name"
            placeholder="Numele și Prenumele"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Telefon"
            value={formData.phone}
            onChange={handleChange}
          />
          <textarea
            name="message"
            placeholder="Mesaj"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <select name="topic" value={formData.topic} onChange={handleChange}>
            <option value="Sesizare cu privire la CCM">Sesizare cu privire la CCM</option>
            <option value="Întrebare generală">Întrebare generală</option>
            <option value="Propunere de colaborare">Propunere de colaborare</option>
          </select>

          {/* TODO: integrează reCAPTCHA aici */}

          <button type="submit">Trimite</button>
        </form>
      </div>
      <Footer />
    </div>
  );
}
